import { Error404 } from '@/components/_ui/Error404'
import LandingPageLayout from '@/components/Layouts/LandingPageLayout'

const Custom404 = () => (
  <LandingPageLayout>
    <main className="color flex min-h-screen flex-col items-center justify-center overflow-x-clip px-8 pb-0 md:pt-2 lg:pt-20">
      <Error404 />
    </main>
  </LandingPageLayout>
)

export default Custom404
